<div class="details-page-wrapper" *ngIf="company != undefined && contactTags != undefined && featureFlagsLoaded">
  <div class="details-scroll-content">
    <dx-validation-group #companyValidationGroup>
    <div class="gpd-form-grid">
      <div class="gpd-form-column">
        <div class="gpd-form-card">
          <div class="gpd-form-card-header">
            <app-svg-icon icon="building" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
            <span class="gpd-form-card-title" i18n="@@companyDetails">Company Details</span>
          </div>

          <div class="gpd-form-row">
            <div class="gpd-form-field">
              <label class="gpd-form-label gpd-form-required"><span i18n="@@name">Name</span></label>
              <dx-text-box class="gpd-input" [(value)]="company.name" [readOnly]="!editMode" i18n-placeholder="@@companyNamePlaceholder" placeholder="e.g. Sample Company Ltd.">
                <dx-validator>
                  <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@phone">Phone</label>
              <dx-text-box class="gpd-input" [(value)]="company.phone" [readOnly]="!editMode" i18n-placeholder="@@phonePlaceholder" placeholder="e.g. +49 30 1234567"></dx-text-box>
            </div>
          </div>
        </div>

        <div class="gpd-form-card">
          <div class="gpd-form-card-header">
            <app-svg-icon icon="location" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
            <span class="gpd-form-card-title" i18n="@@address">Address</span>
          </div>

          <div class="gpd-form-row">
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@address">Address</label>
              <dx-text-box class="gpd-input" [(value)]="company.address" [readOnly]="!editMode" i18n-placeholder="@@addressPlaceholder" placeholder="e.g. Main Street 1"></dx-text-box>
            </div>
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@addition">Addition</label>
              <dx-text-box class="gpd-input" [(value)]="company.addition" [readOnly]="!editMode" i18n-placeholder="@@additionPlaceholder" placeholder="e.g. Building 2"></dx-text-box>
            </div>
          </div>

          <div class="gpd-form-row">
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@zipcode">Zipcode</label>
              <dx-text-box class="gpd-input" [(value)]="company.zipcode" [readOnly]="!editMode" i18n-placeholder="@@zipcodePlaceholder" placeholder="e.g. 12345"></dx-text-box>
            </div>
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@city">City</label>
              <dx-text-box class="gpd-input" [(value)]="company.city" [readOnly]="!editMode" i18n-placeholder="@@cityPlaceholder" placeholder="e.g. Berlin"></dx-text-box>
            </div>
          </div>

          <div class="gpd-form-row gpd-form-row--half">
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@country">Country</label>
              <dx-select-box
                class="gpd-input"
                [readOnly]="!editMode"
                [(value)]="company.countryId"
                [dataSource]="countriesByLanguageList"
                (onSelectionChanged)="handleCountryChange(company.countryId)"
                displayExpr="countryName"
                valueExpr="countryId"
                acceptCustomValue="false"
                i18n-placeholder="@@pleaseSelect"
                placeholder="Please Select"
              ></dx-select-box>
            </div>
          </div>
        </div>

        <div class="gpd-form-card">
          <div class="gpd-form-card-header gpd-form-card-header--actions">
            <div class="gpd-form-card-header__label">
              <app-svg-icon icon="user-multiple" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@contactPersons">Contact Persons</span>
            </div>
            <app-gpd-button
              type="text"
              i18n-text="@@addPerson"
              text="Add Person"
              icon="add"
              (onClick)="showPersonPopup($event)"
              [disabled]="!editMode"
            ></app-gpd-button>
          </div>

          <div *ngIf="companyPersons?.length > 0" class="person-card-list">
            <div class="person-card" *ngFor="let person of companyPersons">
              <div class="person-card-main">
                <div class="person-card-name-row">
                  <span class="person-card-name" (click)="gotoContact(person)">{{ person.firstname }} {{ person.lastname }}</span>
                </div>
                <div class="person-card-contact-row">
                  <span class="person-card-contact-item" *ngIf="editMode !== true || person.editMode !== true">
                    <app-svg-icon icon="briefcase" [size]="16" color="var(--color-grey-500)"></app-svg-icon>
                    <span *ngIf="person.role">{{ person.role }}</span>
                    <span *ngIf="!person.role" class="person-card-contact-placeholder" i18n="@@noRole">No role</span>
                  </span>
                  <span class="person-card-contact-item" *ngIf="editMode === true && person.editMode === true">
                    <app-svg-icon icon="briefcase" [size]="16" color="var(--color-grey-500)"></app-svg-icon>
                    <dx-text-box
                      class="gpd-input person-card-role-input"
                      (onBlur)="handleRoleBlur({ data: person })"
                      [(value)]="person.role"
                      maxLength="200"
                      i18n-placeholder="@@rolePlaceholder"
                      placeholder="e.g. Purchasing Manager"
                    ></dx-text-box>
                  </span>
                  <span class="person-card-contact-item" *ngIf="person.email">
                    <app-svg-icon icon="mail" [size]="16" color="var(--color-grey-500)"></app-svg-icon>
                    {{ person.email }}
                  </span>
                  <span class="person-card-contact-item">
                    <app-svg-icon icon="phone" [size]="16" color="var(--color-grey-500)"></app-svg-icon>
                    <span *ngIf="person.phoneMobile">{{ person.phoneMobile }}</span>
                    <span *ngIf="!person.phoneMobile" class="person-card-contact-placeholder" i18n="@@noPhoneNumber">No phone number</span>
                  </span>
                </div>
              </div>
              <div class="person-card-actions">
                <button
                  type="button"
                  class="person-card-icon-btn"
                  (click)="person.editMode = true"
                  [disabled]="!editMode"
                  i18n-title="@@edit"
                  title="Edit"
                >
                  <app-svg-icon icon="edit" [size]="16"></app-svg-icon>
                </button>
                <button
                  type="button"
                  class="person-card-icon-btn person-card-remove-btn"
                  (click)="confirmRemovePersonFromCompany(person)"
                  [disabled]="!editMode"
                  i18n-title="@@remove"
                  title="Remove"
                >
                  <app-svg-icon icon="delete" [size]="16"></app-svg-icon>
                </button>
              </div>
            </div>
          </div>
          <p *ngIf="!(companyPersons?.length > 0)" class="gpd-form-empty-hint" i18n="@@noContactPersons">No contact persons yet.</p>

          <app-delete-popup
            [visible]="removePersonConfirmVisible"
            i18n-title="@@removePerson"
            title="Remove person"
            [message]="removePersonConfirmMessage"
            (onConfirm)="onRemovePersonConfirmed()"
            (onAbort)="onRemovePersonAborted()"
            (visibleChange)="removePersonConfirmVisible = $event"
          ></app-delete-popup>
        </div>
      </div>

      <div class="gpd-form-column gpd-form-column--side">
        <div class="gpd-form-card">
          <div class="gpd-form-card-header">
            <app-svg-icon icon="tag" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
            <span class="gpd-form-card-title" i18n="@@tags">Tags</span>
          </div>

          <!-- The tag-box's own chip rendering is hidden (see .cap-tags-dropdown in the CSS) —
               selected tags show as pills below; this stays purely a control for
               adding/removing tags via its dropdown checklist. DevExtreme only renders its own
               placeholder when the value is genuinely empty, so a static one is layered on top
               instead — always visible, steps aside only while actually focused. -->
          <div class="cap-tags-dropdown-wrapper" *ngIf="editMode">
            <dx-tag-box
              class="gpd-input cap-tags-dropdown"
              [(value)]="company.tags"
              [items]="contactTags"
              displayExpr="title"
              valueExpr="id"
              [showSelectionControls]="true"
              [showDropDownButton]="true"
              applyValueMode="useButtons"
            ></dx-tag-box>
            <span class="cap-tags-placeholder" i18n="@@assignTags">Assign tags</span>
          </div>

          <div class="contact-tag-container" *ngIf="company.tags?.length">
            <gpd-pill
              *ngFor="let tag of company.tags"
              [text]="getTag(tag)"
              backgroundColor="var(--color-secondary)"
              color="var(--color-primary)"
              [removable]="editMode"
              (onRemove)="removeTag(tag)"
            ></gpd-pill>
          </div>

          <p *ngIf="!editMode && !company.tags?.length" class="gpd-form-empty-hint" i18n="@@noContactTagsYet">
            No tags yet.
          </p>
        </div>

        <div class="gpd-form-card">
          <div class="gpd-form-card-header gpd-form-card-header--actions">
            <div class="gpd-form-card-header__label">
              <app-svg-icon icon="solar-panel" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@relatedProjects">Related Projects</span>
            </div>
            <div class="linked-projects-header-actions">
              <app-gpd-button
                type="text"
                i18n-text="@@addToProject"
                text="Add to Project"
                icon="add"
                (onClick)="addProjectModalVisible = true"
                [disabled]="!editMode"
              ></app-gpd-button>
            </div>
          </div>

          <dx-text-box
            *ngIf="projectsListScrollable"
            class="gpd-input linked-projects-search"
            [(value)]="relatedProjectsSearchTerm"
            valueChangeEvent="keyup"
            i18n-placeholder="@@searchProject"
            placeholder="Search project"
            [showClearButton]="true"
          ></dx-text-box>

          <div
            #projectsListEl
            *ngIf="relatedProjects?.length > 0 && filteredRelatedProjects.length > 0"
            class="linked-projects-list"
          >
            <div class="linked-project-row" *ngFor="let data of filteredRelatedProjects">
              <app-contracts-pill
                *ngIf="data.project"
                class="linked-project-name"
                linkType="techProject"
                [content]="data.project"
                [displayString]="data.project.projectName"
                [projectStatus]="data.project.status"
              ></app-contracts-pill>
              <div class="role-cell linked-project-roles">
                <span
                  class="role-pill role-pill--source"
                  *ngFor="let route of sourceRouting(data)"
                  [title]="route.description"
                  (click)="onItemClick(data, route)"
                >
                  <span class="role-pill__text">{{ route.description }}</span>
                </span>
                <span class="role-pill role-pill--custom" *ngIf="data.role" [title]="data.role">
                  <span class="role-pill__text">{{ data.role }}</span>
                  <button
                    type="button"
                    class="role-pill__x"
                    i18n-title="@@delete"
                    title="Delete"
                    (click)="removeManualProjectRole(data); $event.stopPropagation()"
                  >
                    ×
                  </button>
                </span>
              </div>
            </div>
          </div>
          <p *ngIf="relatedProjects?.length > 0 && filteredRelatedProjects.length === 0" class="gpd-form-empty-hint" i18n="@@noProjectsMatchSearch">
            No projects match your search.
          </p>

          <span class="linked-projects-count" *ngIf="relatedProjects?.length > 0" i18n="@@projectsCount">
            {{ relatedProjects.length }} Projects
          </span>

          <p *ngIf="!(relatedProjects?.length > 0)" class="gpd-form-empty-hint" i18n="@@noRelatedProjectsYet">
            No related projects yet.
          </p>

          <app-contact-add-project-modal
            *ngIf="addProjectModalVisible"
            [(visible)]="addProjectModalVisible"
            [contactId]="currentCompanyId"
            contactType="company"
            (onSaved)="onProjectAdded()"
          ></app-contact-add-project-modal>

          <app-delete-popup
            [visible]="deleteRoleVisible"
            i18n-title="@@deleteRole"
            title="Delete role"
            [message]="deleteRoleMessage"
            (onConfirm)="onDeleteRoleConfirmed()"
            (onAbort)="onDeleteRoleAborted()"
            (visibleChange)="deleteRoleVisible = $event"
          ></app-delete-popup>
        </div>

        <div class="gpd-form-card" *ngIf="contractsEnabled">
          <div class="gpd-form-card-header">
            <app-svg-icon icon="contracts" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
            <span class="gpd-form-card-title" i18n="@@relatedContractsCaps">Related Contracts</span>
          </div>
          <dx-text-box
            *ngIf="contractsListScrollable"
            class="gpd-input linked-projects-search"
            [(value)]="relatedContractsSearchTerm"
            valueChangeEvent="keyup"
            i18n-placeholder="@@searchContract"
            placeholder="Search contract"
            [showClearButton]="true"
          ></dx-text-box>

          <div
            #contractsListEl
            *ngIf="relatedContracts?.length > 0 && filteredRelatedContracts.length > 0"
            class="linked-projects-list"
          >
            <div class="linked-project-row" *ngFor="let data of filteredRelatedContracts">
              <app-contracts-pill
                class="linked-contract-name"
                linkType="contract"
                [content]="{ contractId: data.id, designation: data.designation }"
              ></app-contracts-pill>
            </div>
          </div>
          <p *ngIf="relatedContracts?.length > 0 && filteredRelatedContracts.length === 0" class="gpd-form-empty-hint" i18n="@@noContractsMatchSearch">
            No contracts match your search.
          </p>

          <span class="linked-projects-count" *ngIf="relatedContracts?.length > 0" i18n="@@contractsCount">
            {{ relatedContracts.length }} Contracts
          </span>

          <p *ngIf="!(relatedContracts?.length > 0)" class="gpd-form-empty-hint" i18n="@@noRelatedContractsYet">
            No related contracts yet.
          </p>
        </div>
      </div>
    </div>
    </dx-validation-group>
  </div>

  <app-form-footer>
    <app-gpd-button footerLeft type="danger" i18n-text="@@delete" text="DELETE" icon="delete" (onClick)="deletePopupVisible = true"></app-gpd-button>
    <app-gpd-button footerRight *ngIf="editMode" type="secondary" i18n-text="@@cancel" icon="cancel" text="CANCEL" (onClick)="goTo('contacts/companies')"></app-gpd-button>
    <app-gpd-button footerRight *ngIf="editMode" i18n-text="@@save" text="SAVE" icon="check" (onClick)="saveChanges()"></app-gpd-button>
  </app-form-footer>

  <app-validation-toast #validationToast></app-validation-toast>
</div>

<dx-popup dragEnabled="true" resizeEnabled="true" [(visible)]="personPopupVisible" (onHidden)="resetPopup($event)">
    <div [ngSwitch]="personEditMode">
        <div class="gt-routes-list-containerss" *ngSwitchCase="false">
            <dx-data-grid #popupPersonGrid [dataSource]="persons" (onRowClick)="onPersonSelected($event)" [allowColumnResizing]="true"
                [columnResizingMode]="'widget'" [columnAutoWidth]="false" [showBorders]="true"
                [scrolling]="{ mode: 'standard', useNative: true }" [width]="'100%'" class="gpd-datagrid gpd-datagrid-slim"
                [hoverStateEnabled]="true">
                <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
                <dxi-column dataField="firstname" caption="Firstname" i18n-caption="@@firstname"> </dxi-column>
                <dxi-column dataField="lastname" caption="Lastname" i18n-caption="@@lastname"> </dxi-column>
                <dxi-column dataField="phonePrivate" caption="Phone (Private)" i18n-caption="@@phonePrivate">
                </dxi-column>
                <dxi-column dataField="phoneCompany" caption="Phone (Work)" i18n-caption="@@phoneWork"> </dxi-column>
                <dxi-column dataField="phoneMobile" caption="Phone (Mobile)" i18n-caption="@@phoneMobile"> </dxi-column>
                <dxi-column dataField="email" caption="Email" i18n-caption="@@email"> </dxi-column>
            </dx-data-grid>
        </div>
        <div *ngSwitchCase="true">
        </div>
    </div>
</dx-popup>

<dx-toast [visible]="toastVisible" [type]="type" message="{{message}}" position="bottom center" width="fit-content">
</dx-toast>

<app-delete-popup [message]="'Do you want to delete this contact?'" [visible]="deletePopupVisible"
    (onAbort)="deletePopupVisible = false" (onConfirm)="deleteCompany($event)"></app-delete-popup>
